import { useEffect, useMemo, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';

const useLearningActivityAssessmentSummary = ({
  schoolId,
  classId,
  lessonId,
  enabled,
  notifyError,
}) => {
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [tables, setTables] = useState([]);
  const reqIdRef = useRef(0);

  const requestBody = useMemo(
    () => ({
      school_id: schoolId,
      class_id: classId,
      lesson_id: lessonId,
    }),
    [schoolId, classId, lessonId]
  );

  useEffect(() => {
    setStudents([]);
    setTables([]);

    if (!enabled || !schoolId || !classId || !lessonId) return;

    const rid = ++reqIdRef.current;

    const run = async () => {
      setLoading(true);
      try {
        const res = await fetchJson(apiUrl('/admin/learning-activity-assessments/summary'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(requestBody),
        });
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('summary');

        const data = await res.json();
        setStudents(Array.isArray(data?.students) ? data.students : []);
        setTables(Array.isArray(data?.tables) ? data.tables : []);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Özet verileri yüklenemedi');
        setStudents([]);
        setTables([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoading(false);
      }
    };

    run();
  }, [enabled, schoolId, classId, lessonId, requestBody, notifyError]);

  return { loading, students, tables };
};

export default useLearningActivityAssessmentSummary;
